import { UserScopeEnum } from "@src/__generated__/graphql";

export const COMMUNICATION_TAB_QUERY_KEY = "commTab";

export const getCommunicationTabQueryValue = (
  scope: UserScopeEnum | undefined,
): UserScopeEnum | undefined => {
  if (scope === UserScopeEnum.Client) return UserScopeEnum.Client;
  if (scope === UserScopeEnum.Partner) return UserScopeEnum.Partner;
  return undefined;
};

export const parseCommunicationTabQueryValue = (
  value: string | string[] | undefined,
): UserScopeEnum | undefined => {
  const normalized = Array.isArray(value) ? value[0] : value;
  if (!normalized) return undefined;
  if (normalized === UserScopeEnum.Client) return UserScopeEnum.Client;
  if (normalized === UserScopeEnum.Partner) return UserScopeEnum.Partner;
  return undefined;
};
